const ui = {
  tagLength: 15,
  evidenceTitleLength: 60,
  theoryTitleLength: 60,
  usernameLength: 15,
  displayNameLength: 30,
};
export default ui;
